import tw from "twin.macro";
import { schemeType } from "../api/NewSchemeApi";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Noimg from "../images/no_img.jpg";
import icon1 from "images/SavingScheme/1.png";
import icon2 from "images/SavingScheme/2.png";
import icon3 from "images/SavingScheme/3.png";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { getCustomerId } from "utility/HeaderConfig";
import { useCartContext } from "context/UseCartContext";
import SEO from "components/headers/Seo";

const Container = tw.div`relative font-display overflow-hidden`;

const BENEFITS = [
  {
    icon: icon1,
    title: "Easy Future",
    desc: "Boon to middle class people. Special help to all class people.",
  },
  {
    icon: icon3,
    title: "Special Discount",
    desc: "Save monthly and earn a special bonus discount on your final jewellery purchase.",
    highlight: true,
  },
  {
    icon: icon2,
    title: "Your Money is Safe",
    desc: "The savings gold amount fetches an admirable bonus, more valuable than a special discount.",
  },
];

export default ({ branch }) => {
  const [Scheme, setScheme] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);
  const { dispatch } = useCartContext();
  const history = useNavigate();

  useEffect(() => {
    setLoading(true);
    schemeType({ visibilityStatus: "Mobile" }).then(
      (d) => { setScheme(d.response.content); setLoading(false); },
      (err) => console.log(err)
    );
  }, []);

  const checkLogin = () => {
    if (getCustomerId()) history("/MyScheme");
    else dispatch({ type: "MODAL", payload: "login" });
  };

  const imgSrc = (item) =>
    item.imageUrl && item.imageUrl !== "" && item.imageUrl !== "-" && item.imageUrl !== "Image_Not_Available"
      ? item.imageUrl : Noimg;

  return (
    <Container>
      <SEO title="Saving Scheme — PMR Venkateswara Jewellery" description="Join our saving scheme." name="PMR Venkateswara Jewellery" type="article" />

      {/* ── Hero / Benefits banner ─────────────────────── */}
      <section style={{
        background: "linear-gradient(135deg,#1c1c1e 0%,#2d2d2f 60%,#1c1c1e 100%)",
        padding: "64px 0",
        position: "relative", overflow: "hidden",
      }}>
        {/* Decorative gold circles */}
        <div style={{ position: "absolute", top: -60, right: -60, width: 280, height: 280, borderRadius: "50%", border: "1px solid rgba(196,164,54,.15)", pointerEvents: "none" }} />
        <div style={{ position: "absolute", bottom: -80, left: -40, width: 240, height: 240, borderRadius: "50%", border: "1px solid rgba(196,164,54,.10)", pointerEvents: "none" }} />

        <div className="container">
          {/* Title */}
          <div style={{ textAlign: "center", marginBottom: 56 }}>
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".16em", textTransform: "uppercase", color: "#f8e2ae", margin: "0 0 10px" }}>
              PMR Venkateswara Jewellery
            </p>
            <h1 style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: "clamp(26px,4vw,40px)", fontWeight: 500, color: "#fff", margin: "0 0 8px", lineHeight: 1.2 }}>
              Benefits of{" "}
              <span style={{ color: "#f3d48d" }}>{"PMR Venkateswara Jewellery"}</span>
            </h1>
            <p style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: "clamp(20px,2.5vw,28px)", fontWeight: 400, color: "#f8e2ae", margin: 0 }}>
              Saving Scheme
            </p>
          </div>

          {/* Benefits grid */}
          <div className="row g-4 justify-content-center">
            {BENEFITS.map((b, i) => (
              <div key={i} className="col-md-4">
                <div style={{
                  background: b.highlight ? "#fff" : "rgba(255,255,255,.06)",
                  border: b.highlight ? "none" : "1px solid rgba(196,164,54,.2)",
                  borderRadius: 20,
                  padding: "32px 28px",
                  textAlign: "center",
                  height: "100%",
                  position: "relative",
                }}>
                  {b.highlight && (
                    <div style={{ position: "absolute", top: -12, left: "50%", transform: "translateX(-50%)", background: "#ebcf8e", color: "#fff", fontSize: 10, fontWeight: 700, letterSpacing: ".1em", textTransform: "uppercase", padding: "3px 14px", borderRadius: 999 }}>
                      Featured
                    </div>
                  )}
                  <img src={b.icon} alt={b.title} style={{ width: 80, height: 80, objectFit: "contain", margin: "0 auto 20px" }} className="spinner" />
                  <h4 style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: 22, fontWeight: 600, color: b.highlight ? "#1c1c1e" : "#fff", margin: "0 0 10px" }}>
                    {b.title}
                  </h4>
                  <p style={{ fontSize: 13.5, lineHeight: 1.7, color: b.highlight ? "#6c6c70" : "rgba(255,255,255,.6)", margin: "0 0 24px" }}>
                    {b.desc}
                  </p>
                  {b.highlight && (
                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                      <a
                        href="#join"
                        style={{
                          display: "block", padding: "11px 20px", textAlign: "center",
                          background: "#7e611e", color: "#fff",
                          fontSize: 12.5, fontWeight: 700, letterSpacing: ".07em", textTransform: "uppercase",
                          borderRadius: 9, textDecoration: "none",
                          transition: "background .14s",
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = "#9c7a3a"}
                        onMouseLeave={(e) => e.currentTarget.style.background = "#7e611e"}
                      >
                        Join New Saving Scheme
                      </a>
                      <button
                        onClick={checkLogin}
                        style={{
                          display: "block", width: "100%", padding: "11px 20px",
                          background: "#b8860b", color: "#fff",
                          fontSize: 12.5, fontWeight: 700, letterSpacing: ".07em", textTransform: "uppercase",
                          border: "none", borderRadius: 9, cursor: "pointer",
                          transition: "background .14s",
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = "#9c7a3a"}
                        onMouseLeave={(e) => e.currentTarget.style.background = "#b8860b"}
                      >
                        Pay Monthly Scheme
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Scheme cards ─────────────────────────────────── */}
      <section style={{ padding: "64px 0 80px", background: "#fff" }} id="join">
        <div className="container">
          {/* Header */}
          <div style={{ textAlign: "center", marginBottom: 48 }}>
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".16em", textTransform: "uppercase", color: "#9c7a3a", margin: "0 0 8px" }}>
              Choose Your Plan
            </p>
            <h2 style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: "clamp(26px,4vw,38px)", fontWeight: 500, color: "#6b5330", margin: "0 0 10px" }}>
              Available Schemes
            </h2>
            <p style={{ fontSize: 14, color: "#e0c17e", margin: 0 }}>
              Select a saving scheme that fits your goals
            </p>
          </div>

          {/* Grid */}
          {loading ? (
            <div className="row g-4">
              {[1, 2, 3].map((i) => (
                <div key={i} className="col-md-6 col-xl-4">
                  <div style={{ borderRadius: 16, overflow: "hidden", border: "1px solid #f2f2f7" }}>
                    <Skeleton style={{ height: 261 }} />
                    <div style={{ padding: 20 }}>
                      <Skeleton height={14} style={{ marginBottom: 8, borderRadius: 4 }} />
                      <Skeleton height={12} count={3} style={{ marginBottom: 6, borderRadius: 4 }} />
                      <Skeleton height={40} style={{ borderRadius: 9, marginTop: 12 }} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="row g-4">
              {Scheme.map((item) => (
                <div key={item.id} className="col-md-6 col-xl-4">
                  <div style={{
                    borderRadius: 16, overflow: "hidden",
                    border: "1px solid #f2f2f7", background: "#fff",
                    boxShadow: "0 2px 12px rgba(0,0,0,.06)",
                    transition: "box-shadow .24s, transform .24s",
                    height: "100%", display: "flex", flexDirection: "column",
                  }}
                    onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 12px 40px rgba(0,0,0,.12)"; e.currentTarget.style.transform = "translateY(-4px)"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,0,0,.06)"; e.currentTarget.style.transform = "none"; }}
                  >
                    {/* Image */}
                    <div style={{ overflow: "hidden", background: "#fafafa" }}>
                      <img
                        src={imgSrc(item)}
                        alt={item.name}
                        style={{ width: "100%", height: 240, objectFit: "cover", display: "block", transition: "transform .4s" }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.04)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "none"}
                      />
                    </div>

                    {/* Body */}
                    <div style={{ padding: "20px 22px", flex: 1, display: "flex", flexDirection: "column" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                        <h5 style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: 20, fontWeight: 600, color: "#6b5330", margin: 0 }}>
                          {item.name}
                        </h5>
                        <span style={{ display: "inline-block", padding: "2px 9px", background: "#efd8fa", border: "1px solid #f0ddb0", borderRadius: 999, fontSize: 11, fontWeight: 700, color: "#c9a34d", letterSpacing: ".05em" }}>
                          {item.type}
                        </span>
                      </div>

                      {item.description && item.description !== "" && (
                        <div style={{ flex: 1 }}>
                          <p style={{ fontSize: 13.5, lineHeight: 1.7, color: "#48484a", margin: "0 0 4px" }}>
                            {expandedId === item.id ? item.description : item.description.slice(0, 150)}
                            {item.description.length > 150 && (
                              <button
                                onClick={() => setExpandedId(expandedId === item.id ? null : item.id)}
                                style={{ background: "none", border: "none", padding: 0, marginLeft: 4, fontSize: 12.5, fontWeight: 700, color: "#c9a34d", cursor: "pointer" }}
                              >
                                {expandedId === item.id ? "Show less" : "Read more"}
                              </button>
                            )}
                          </p>
                        </div>
                      )}

                      <button
                        onClick={() => history("/SchemeDetails", { state: { item: item.id } })}
                        style={{
                          display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                          marginTop: 16, padding: "12px 20px",
                          background: "#6b5330", color: "#fff",
                          fontSize: 13, fontWeight: 600, letterSpacing: ".05em",
                          border: "none", borderRadius: 9, cursor: "pointer",
                          width: "100%", transition: "background .14s",
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = "#9c7a3a"}
                        onMouseLeave={(e) => e.currentTarget.style.background = "#6b5330"}
                      >
                        View Scheme Details
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* CTA strip */}
          <div style={{
            marginTop: 56, padding: "32px 40px",
            background: "linear-gradient(135deg,#f5e4f8,#f0dfb3)",
            border: "1px solid #f0ddb0", borderRadius: 20,
            display: "flex", justifyContent: "space-between", alignItems: "center",
            gap: 20, flexWrap: "wrap",
          }}>
            <div>
              <h3 style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: 24, fontWeight: 600, color: "#6b5330", margin: "0 0 6px" }}>
                Already a member?
              </h3>
              <p style={{ fontSize: 14, color: "#b8860b", margin: 0 }}>
                Sign in to view and manage your active saving scheme.
              </p>
            </div>
            <button
              onClick={checkLogin}
              style={{
                display: "inline-flex", alignItems: "center", gap: 8,
                padding: "13px 28px",
                background: "#6b5330", color: "#fff",
                fontSize: 13, fontWeight: 700, letterSpacing: ".06em",
                border: "none", borderRadius: 10, cursor: "pointer",
                transition: "background .14s", whiteSpace: "nowrap",
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = "#9c7a3a"}
              onMouseLeave={(e) => e.currentTarget.style.background = "#6b5330"}
            >
              Pay Monthly Scheme
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
              </svg>
            </button>
          </div>
        </div>
      </section>
    </Container>
  );
};